import { TaxableSourceType } from "@mimber/schema"
import type { OrganizationTaxRateAssignmentDto } from "@mimber/schema"

/** No-tax sentinel value used in the select fields (empty string, converted to null on submit) */
export const NO_TAX_VALUE = ""

/** Human-readable labels for each taxable revenue source type */
export const TAXABLE_SOURCE_TYPE_LABELS: Record<TaxableSourceType, string> = {
  [TaxableSourceType.MEMBERSHIP_TIER]: "Membership Dues",
  [TaxableSourceType.EVENT]: "Event Tickets",
  [TaxableSourceType.STORE_PURCHASE]: "Store Purchases",
  [TaxableSourceType.DONATION]: "Donations",
  [TaxableSourceType.CUSTOM]: "Custom Invoices",
}

/** Stable, display-friendly order for the assignment fields */
export const TAXABLE_SOURCE_TYPE_ORDER: TaxableSourceType[] = [
  TaxableSourceType.MEMBERSHIP_TIER,
  TaxableSourceType.EVENT,
  TaxableSourceType.STORE_PURCHASE,
  TaxableSourceType.DONATION,
  TaxableSourceType.CUSTOM,
]

export type TaxRateAssignmentsFormData = Record<TaxableSourceType, string>

/** Build form default values from the current assignments (unassigned -> NO_TAX_VALUE) */
export function buildAssignmentsFormDefaults(
  assignments: OrganizationTaxRateAssignmentDto[]
): TaxRateAssignmentsFormData {
  const bySourceType = new Map(
    assignments.map((assignment) => [assignment.sourceType, assignment])
  )

  return TAXABLE_SOURCE_TYPE_ORDER.reduce((acc, sourceType) => {
    acc[sourceType] =
      bySourceType.get(sourceType)?.taxRate?.uuid ?? NO_TAX_VALUE
    return acc
  }, {} as TaxRateAssignmentsFormData)
}
